<section class="pb-14">
  @if (filters(); as filters) {
    <div class="desk:centered-with-padding no-scrollbar flex w-screen overflow-x-auto px-5 pb-7">
      <app-filter-toggle-group [filterName]="filterName" [filters]="filters" />
    </div>
  }
  @if (furnitures(); as furnitures) {
    <div class="centered-with-padding grid grid-cols-1 gap-y-6 desk:grid-cols-3 desk:gap-x-3 desk:gap-y-[18px]">
      @for (furniture of furnitures; track $index) {
        @if ($index === 4) {
          <div class="desk:hidden">
            <ng-container *ngTemplateOutlet="breathingContent" />
          </div>
        }
        @if ($index === 6) {
          <div class="hidden desk:col-span-3 desk:block">
            <ng-container *ngTemplateOutlet="breathingContent" />
          </div>
        }
        <div
          class="grid h-full grid-rows-[1fr-auto] gap-y-2.5 overflow-hidden rounded-[25px] border-[3px] border-gray-light p-2.5">
          <div (click)="openVisualFullScreenModal(furniture.image)" class="group relative h-[196px] cursor-zoom-in">
            <app-image
              [hoverEffect]="true"
              [image]="furniture.image"
              [isPriority]="!isImageInPreviousBlocks && $index < 3"
              [keepAspectRatio]="true" />
          </div>
          <div class="drop-shadow-custom flex flex-col gap-y-2.5 rounded-[14px] bg-gray-light px-5 py-[14px]">
            <span class="font-title text-[18px] leading-[20px] tracking-[-0.36px]">{{ furniture.title }}</span>
            @if (furniture.width) {
              <div class="flex flex-col">
                <span>{{ "COMPONENT.LISTING-MEUBLES-IMAGE-NOM-DESCRIPTION.AVAILABLE_WIDTHS" | translate }}</span>
                <span>{{ furniture.width }}</span>
              </div>
            }
            @if (furniture.height) {
              <div class="flex flex-col">
                <span>{{ "COMPONENT.LISTING-MEUBLES-IMAGE-NOM-DESCRIPTION.AVAILABLE_HEIGHTS" | translate }}</span>
                <span>{{ furniture.height }}</span>
              </div>
            }
          </div>
        </div>
      }
    </div>
  } @else {
    <app-grid-skeleton
      gridClass="centered-with-padding grid grid-cols-1 gap-y-6 desk:grid-cols-3 desk:gap-x-3 desk:gap-y-[18px]"
      itemClass="h-[360px]"
      [count]="6" />
  }
  @if (data.infoText; as infoText) {
    <div class="centered-with-padding">
      <div class="mt-5 flex items-center gap-x-4 rounded-2xl bg-gray-light p-4 desk:w-fit">
        <div class="flex size-5 shrink-0 items-center justify-center rounded-md bg-purple">
          <app-svg [height]="20" [width]="20" src="assets/icons/info.svg" />
        </div>
        <span>{{ infoText }}</span>
      </div>
    </div>
  }
</section>

<ng-template #breathingContent>
  <div class="flex size-full items-center justify-center gap-x-2.5 py-9 desk:gap-x-8 desk:p-6 desk:px-24">
    <app-svg [height]="161" [src]="data.iconText.icon.svg" [width]="136" />
    <app-title [title]="{ text: data.iconText.text, as: 'span' }" size="h2" />
  </div>
</ng-template>
